var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('DragPlaceholder'),_c('RightClickMenu',{directives:[{name:"permission",rawName:"v-permission",value:('full'),expression:"'full'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }